import { render } from "./contact-details.vue?vue&type=template&id=76979306&scoped=true"
import script from "./contact-details.vue?vue&type=script&lang=js"
export * from "./contact-details.vue?vue&type=script&lang=js"

import "./contact-details.vue?vue&type=style&index=0&id=76979306&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76979306"]])

export default __exports__